var ISO19139_GMX_20060504_Module_Factory = function () {
  var ISO19139_GMX_20060504 = {
    n: 'ISO19139_GMX_20060504',
    dens: 'http:\/\/www.isotc211.org\/2005\/gmx',
    dans: 'http:\/\/www.w3.org\/1999\/xlink',
    deps: ['XLink_1_0', 'GML_3_2_0', 'ISO19139_GCO_20060504', 'ISO19139_GMD_20060504'],
    tis: [{
        ln: 'MLPrimeMeridianType',
        tn: 'ML_PrimeMeridian_Type',
        bti: 'GML_3_2_0.PrimeMeridianType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.PrimeMeridianAltPropertyType'
          }]
      }, {
        ln: 'CTEllipsoidPropertyType',
        tn: 'CT_Ellipsoid_PropertyType',
        ps: [{
            n: 'ellipsoid',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'Ellipsoid',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.EllipsoidType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLEllipsoidalCSType',
        tn: 'ML_EllipsoidalCS_Type',
        bti: 'GML_3_2_0.EllipsoidalCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLPolarCSType',
        tn: 'ML_PolarCS_Type',
        bti: 'GML_3_2_0.PolarCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLOperationMethodPropertyType',
        tn: 'ML_OperationMethod_PropertyType',
        ps: [{
            n: 'mlOperationMethod',
            rq: true,
            en: 'ML_OperationMethod',
            ti: '.MLOperationMethodType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLTimeCSPropertyType',
        tn: 'ML_TimeCS_PropertyType',
        ps: [{
            n: 'mlTimeCS',
            rq: true,
            en: 'ML_TimeCS',
            ti: '.MLTimeCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCodelistValuePropertyType',
        tn: 'CT_CodelistValue_PropertyType',
        ps: [{
            n: 'codeDefinition',
            rq: true,
            mx: false,
            dom: false,
            en: 'CodeDefinition',
            ti: '.CodeDefinitionType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'BaseUnitPropertyType',
        tn: 'BaseUnit_PropertyType',
        ps: [{
            n: 'baseUnit',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'BaseUnit',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.BaseUnitType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLVerticalDatumType',
        tn: 'ML_VerticalDatum_Type',
        bti: 'GML_3_2_0.VerticalDatumType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.DatumAltPropertyType'
          }]
      }, {
        ln: 'PrimeMeridianAltPropertyType',
        tn: 'PrimeMeridianAlt_PropertyType',
        ps: [{
            n: 'primeMeridianAlt',
            rq: true,
            en: 'PrimeMeridianAlt',
            ti: '.PrimeMeridianAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLCodeListDictionaryPropertyType',
        tn: 'ML_CodeListDictionary_PropertyType',
        ps: [{
            n: 'mlCodeListDictionary',
            rq: true,
            en: 'ML_CodeListDictionary',
            ti: '.MLCodeListDictionaryType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'FileNamePropertyType',
        tn: 'FileName_PropertyType',
        ps: [{
            n: 'fileName',
            rq: true,
            en: 'FileName',
            ti: '.FileNameType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }]
      }, {
        ln: 'MXScopeCodePropertyType',
        tn: 'MX_ScopeCode_PropertyType',
        ps: [{
            n: 'mxScopeCode',
            rq: true,
            en: 'MX_ScopeCode',
            ti: 'ISO19139_GCO_20060504.CodeListValueType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLBaseUnitPropertyType',
        tn: 'ML_BaseUnit_PropertyType',
        ps: [{
            n: 'mlBaseUnit',
            rq: true,
            en: 'ML_BaseUnit',
            ti: '.MLBaseUnitType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractCTCatalogueType',
        tn: 'AbstractCT_Catalogue_Type',
        bti: 'ISO19139_GCO_20060504.AbstractObjectType',
        ps: [{
            n: 'name',
            rq: true,
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'scope',
            rq: true,
            col: true,
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'fieldOfApplication',
            mno: 0,
            col: true,
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'versionNumber',
            rq: true,
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'versionDate',
            rq: true,
            ti: 'ISO19139_GCO_20060504.DatePropertyType'
          }, {
            n: 'language',
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'characterSet',
            ti: 'ISO19139_GMD_20060504.MDCharacterSetCodePropertyType'
          }, {
            n: 'locale',
            mno: 0,
            col: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'subCatalogue',
            mno: 0,
            col: true,
            ti: '.CTCataloguePropertyType'
          }]
      }, {
        ln: 'MLCoordinateSystemAxisType',
        tn: 'ML_CoordinateSystemAxis_Type',
        bti: 'GML_3_2_0.CoordinateSystemAxisType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAxisAltPropertyType'
          }]
      }, {
        ln: 'CodeAlternativeExpressionType',
        tn: 'CodeAlternativeExpression_Type',
        bti: 'GML_3_2_0.DefinitionType',
        ps: [{
            n: 'locale',
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'OperationParameterAltType',
        tn: 'OperationParameterAlt_Type',
        bti: 'GML_3_2_0.OperationParameterType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MXAggregateType',
        tn: 'MX_Aggregate_Type',
        bti: 'ISO19139_GMD_20060504.AbstractDSAggregateType',
        ps: [{
            n: 'aggregateCatalogue',
            mno: 0,
            col: true,
            ti: '.CTCataloguePropertyType'
          }, {
            n: 'aggregateFile',
            mno: 0,
            col: true,
            ti: '.MXSupportFilePropertyType'
          }]
      }, {
        ln: 'CTDatumPropertyType',
        tn: 'CT_Datum_PropertyType',
        ps: [{
            n: 'abstractDatum',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDatum',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.AbstractDatumType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MXFilePropertyType',
        tn: 'MX_File_PropertyType',
        ps: [{
            n: 'abstractMXFile',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractMX_File',
            ti: '.AbstractMXFileType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLGeodeticCRSType',
        tn: 'ML_GeodeticCRS_Type',
        bti: 'GML_3_2_0.GeodeticCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'MLOperationParameterPropertyType',
        tn: 'ML_OperationParameter_PropertyType',
        ps: [{
            n: 'mlOperationParameter',
            rq: true,
            en: 'ML_OperationParameter',
            ti: '.MLOperationParameterType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLCodeListDictionaryType',
        tn: 'ML_CodeListDictionary_Type',
        bti: '.CodeListDictionaryType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.ClAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'MLDerivedCRSPropertyType',
        tn: 'ML_DerivedCRS_PropertyType',
        ps: [{
            n: 'mlDerivedCRS',
            rq: true,
            en: 'ML_DerivedCRS',
            ti: '.MLDerivedCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCataloguePropertyType',
        tn: 'CT_Catalogue_PropertyType',
        ps: [{
            n: 'abstractCTCatalogue',
            rq: true,
            mx: false,
            dom: false,
            en: 'AbstractCT_Catalogue',
            ti: '.AbstractCTCatalogueType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLPassThroughOperationType',
        tn: 'ML_PassThroughOperation_Type',
        bti: 'GML_3_2_0.PassThroughOperationType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationAltPropertyType'
          }]
      }, {
        ln: 'MLOperationParameterGroupPropertyType',
        tn: 'ML_OperationParameterGroup_PropertyType',
        ps: [{
            n: 'mlOperationParameterGroup',
            rq: true,
            en: 'ML_OperationParameterGroup',
            ti: '.MLOperationParameterGroupType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLConcatenatedOperationPropertyType',
        tn: 'ML_ConcatenatedOperation_PropertyType',
        ps: [{
            n: 'mlConcatenatedOperation',
            rq: true,
            en: 'ML_ConcatenatedOperation',
            ti: '.MLConcatenatedOperationType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLSphericalCSType',
        tn: 'ML_SphericalCS_Type',
        bti: 'GML_3_2_0.SphericalCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'OperationAltType',
        tn: 'OperationAlt_Type',
        bti: 'GML_3_2_0.AbstractCoordinateOperationType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLTemporalCRSPropertyType',
        tn: 'ML_TemporalCRS_PropertyType',
        ps: [{
            n: 'mlTemporalCRS',
            rq: true,
            en: 'ML_TemporalCRS',
            ti: '.MLTemporalCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CodeDefinitionPropertyType',
        tn: 'CodeDefinition_PropertyType',
        ps: [{
            n: 'codeDefinition',
            rq: true,
            mx: false,
            dom: false,
            en: 'CodeDefinition',
            ti: '.CodeDefinitionType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLProjectedCRSPropertyType',
        tn: 'ML_ProjectedCRS_PropertyType',
        ps: [{
            n: 'mlProjectedCRS',
            rq: true,
            en: 'ML_ProjectedCRS',
            ti: '.MLProjectedCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CodeDefinitionType',
        tn: 'CodeDefinition_Type',
        bti: 'GML_3_2_0.DefinitionType'
      }, {
        ln: 'OperationParameterAltPropertyType',
        tn: 'OperationParameterAlt_PropertyType',
        ps: [{
            n: 'operationParameterAlt',
            rq: true,
            en: 'OperationParameterAlt',
            ti: '.OperationParameterAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLTemporalCRSType',
        tn: 'ML_TemporalCRS_Type',
        bti: 'GML_3_2_0.TemporalCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'MLEngineeringCRSType',
        tn: 'ML_EngineeringCRS_Type',
        bti: 'GML_3_2_0.EngineeringCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'MLCylindricalCSPropertyType',
        tn: 'ML_CylindricalCS_PropertyType',
        ps: [{
            n: 'mlCylindricalCS',
            rq: true,
            en: 'ML_CylindricalCS',
            ti: '.MLCylindricalCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLImageDatumPropertyType',
        tn: 'ML_ImageDatum_PropertyType',
        ps: [{
            n: 'mlImageDatum',
            rq: true,
            en: 'ML_ImageDatum',
            ti: '.MLImageDatumType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLVerticalDatumPropertyType',
        tn: 'ML_VerticalDatum_PropertyType',
        ps: [{
            n: 'mlVerticalDatum',
            rq: true,
            en: 'ML_VerticalDatum',
            ti: '.MLVerticalDatumType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLPrimeMeridianPropertyType',
        tn: 'ML_PrimeMeridian_PropertyType',
        ps: [{
            n: 'mlPrimeMeridian',
            rq: true,
            en: 'ML_PrimeMeridian',
            ti: '.MLPrimeMeridianType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLBaseUnitType',
        tn: 'ML_BaseUnit_Type',
        bti: 'GML_3_2_0.BaseUnitType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.UomAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'MLCodeDefinitionPropertyType',
        tn: 'ML_CodeDefinition_PropertyType',
        ps: [{
            n: 'mlCodeDefinition',
            rq: true,
            en: 'ML_CodeDefinition',
            ti: '.MLCodeDefinitionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLPolarCSPropertyType',
        tn: 'ML_PolarCS_PropertyType',
        ps: [{
            n: 'mlPolarCS',
            rq: true,
            en: 'ML_PolarCS',
            ti: '.MLPolarCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCrsCataloguePropertyType',
        tn: 'CT_CrsCatalogue_PropertyType',
        ps: [{
            n: 'ctCrsCatalogue',
            rq: true,
            en: 'CT_CrsCatalogue',
            ti: '.CTCrsCatalogueType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLEngineeringDatumPropertyType',
        tn: 'ML_EngineeringDatum_PropertyType',
        ps: [{
            n: 'mlEngineeringDatum',
            rq: true,
            en: 'ML_EngineeringDatum',
            ti: '.MLEngineeringDatumType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MXDataFilePropertyType',
        tn: 'MX_DataFile_PropertyType',
        ps: [{
            n: 'mxDataFile',
            rq: true,
            en: 'MX_DataFile',
            ti: '.MXDataFileType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLUnitDefinitionType',
        tn: 'ML_UnitDefinition_Type',
        bti: 'GML_3_2_0.UnitDefinitionType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.UomAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'MLImageCRSType',
        tn: 'ML_ImageCRS_Type',
        bti: 'GML_3_2_0.ImageCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'UnitDefinitionPropertyType',
        tn: 'UnitDefinition_PropertyType',
        ps: [{
            n: 'unitDefinition',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'UnitDefinition',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.UnitDefinitionType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLOperationParameterGroupType',
        tn: 'ML_OperationParameterGroup_Type',
        bti: 'GML_3_2_0.OperationParameterGroupType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationParameterAltPropertyType'
          }]
      }, {
        ln: 'CTCodelistPropertyType',
        tn: 'CT_Codelist_PropertyType',
        ps: [{
            n: 'codeListDictionary',
            rq: true,
            mx: false,
            dom: false,
            en: 'CodeListDictionary',
            ti: '.CodeListDictionaryType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CoordinateSystemAltPropertyType',
        tn: 'CoordinateSystemAlt_PropertyType',
        ps: [{
            n: 'coordinateSystemAlt',
            rq: true,
            en: 'CoordinateSystemAlt',
            ti: '.CoordinateSystemAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLTransformationPropertyType',
        tn: 'ML_Transformation_PropertyType',
        ps: [{
            n: 'mlTransformation',
            rq: true,
            en: 'ML_Transformation',
            ti: '.MLTransformationType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLGeodeticDatumType',
        tn: 'ML_GeodeticDatum_Type',
        bti: 'GML_3_2_0.GeodeticDatumType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.DatumAltPropertyType'
          }]
      }, {
        ln: 'EllipsoidAltType',
        tn: 'EllipsoidAlt_Type',
        bti: 'GML_3_2_0.IdentifiedObjectType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'OperationMethodAltType',
        tn: 'OperationMethodAlt_Type',
        bti: 'GML_3_2_0.IdentifiedObjectType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLVerticalCRSPropertyType',
        tn: 'ML_VerticalCRS_PropertyType',
        ps: [{
            n: 'mlVerticalCRS',
            rq: true,
            en: 'ML_VerticalCRS',
            ti: '.MLVerticalCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTUomCatalogueType',
        tn: 'CT_UomCatalogue_Type',
        bti: '.AbstractCTCatalogueType',
        ps: [{
            n: 'uomItem',
            rq: true,
            col: true,
            ti: '.UnitDefinitionPropertyType'
          }]
      }, {
        ln: 'CTPrimeMeridianPropertyType',
        tn: 'CT_PrimeMeridian_PropertyType',
        ps: [{
            n: 'primeMeridian',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'PrimeMeridian',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.PrimeMeridianType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MimeFileTypePropertyType',
        tn: 'MimeFileType_PropertyType',
        ps: [{
            n: 'mimeFileType',
            rq: true,
            en: 'MimeFileType',
            ti: '.MimeFileTypeType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }]
      }, {
        ln: 'CodeListDictionaryPropertyType',
        tn: 'CodeListDictionary_PropertyType',
        ps: [{
            n: 'codeListDictionary',
            rq: true,
            mx: false,
            dom: false,
            en: 'CodeListDictionary',
            ti: '.CodeListDictionaryType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLUnitDefinitionPropertyType',
        tn: 'ML_UnitDefinition_PropertyType',
        ps: [{
            n: 'mlUnitDefinition',
            rq: true,
            en: 'ML_UnitDefinition',
            ti: '.MLUnitDefinitionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLDerivedUnitType',
        tn: 'ML_DerivedUnit_Type',
        bti: 'GML_3_2_0.DerivedUnitType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.UomAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'MLTimeCSType',
        tn: 'ML_TimeCS_Type',
        bti: 'GML_3_2_0.TimeCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLConventionalUnitPropertyType',
        tn: 'ML_ConventionalUnit_PropertyType',
        ps: [{
            n: 'mlConventionalUnit',
            rq: true,
            en: 'ML_ConventionalUnit',
            ti: '.MLConventionalUnitType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLTemporalDatumPropertyType',
        tn: 'ML_TemporalDatum_PropertyType',
        ps: [{
            n: 'mlTemporalDatum',
            rq: true,
            en: 'ML_TemporalDatum',
            ti: '.MLTemporalDatumType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'EllipsoidAltPropertyType',
        tn: 'EllipsoidAlt_PropertyType',
        ps: [{
            n: 'ellipsoidAlt',
            rq: true,
            en: 'EllipsoidAlt',
            ti: '.EllipsoidAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLImageDatumType',
        tn: 'ML_ImageDatum_Type',
        bti: 'GML_3_2_0.ImageDatumType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.DatumAltPropertyType'
          }]
      }, {
        ln: 'MLEllipsoidPropertyType',
        tn: 'ML_Ellipsoid_PropertyType',
        ps: [{
            n: 'mlEllipsoid',
            rq: true,
            en: 'ML_Ellipsoid',
            ti: '.MLEllipsoidType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLGeodeticCRSPropertyType',
        tn: 'ML_GeodeticCRS_PropertyType',
        ps: [{
            n: 'mlGeodeticCRS',
            rq: true,
            en: 'ML_GeodeticCRS',
            ti: '.MLGeodeticCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLEngineeringDatumType',
        tn: 'ML_EngineeringDatum_Type',
        bti: 'GML_3_2_0.EngineeringDatumType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.DatumAltPropertyType'
          }]
      }, {
        ln: 'CTCoordinateSystemAxisPropertyType',
        tn: 'CT_CoordinateSystemAxis_PropertyType',
        ps: [{
            n: 'coordinateSystemAxis',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'CoordinateSystemAxis',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.CoordinateSystemAxisType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLVerticalCSType',
        tn: 'ML_VerticalCS_Type',
        bti: 'GML_3_2_0.VerticalCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLConversionType',
        tn: 'ML_Conversion_Type',
        bti: 'GML_3_2_0.ConversionType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationAltPropertyType'
          }]
      }, {
        ln: 'MLCodeDefinitionType',
        tn: 'ML_CodeDefinition_Type',
        bti: '.CodeDefinitionType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CodeAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'MLVerticalCRSType',
        tn: 'ML_VerticalCRS_Type',
        bti: 'GML_3_2_0.VerticalCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'AbstractMXFileType',
        tn: 'AbstractMX_File_Type',
        bti: 'ISO19139_GCO_20060504.AbstractObjectType',
        ps: [{
            n: 'fileName',
            rq: true,
            ti: '.FileNamePropertyType'
          }, {
            n: 'fileDescription',
            rq: true,
            ti: 'ISO19139_GCO_20060504.CharacterStringPropertyType'
          }, {
            n: 'fileType',
            rq: true,
            ti: '.MimeFileTypePropertyType'
          }]
      }, {
        ln: 'DatumAltType',
        tn: 'DatumAlt_Type',
        bti: 'GML_3_2_0.AbstractDatumType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLEllipsoidalCSPropertyType',
        tn: 'ML_EllipsoidalCS_PropertyType',
        ps: [{
            n: 'mlEllipsoidalCS',
            rq: true,
            en: 'ML_EllipsoidalCS',
            ti: '.MLEllipsoidalCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLAffineCSPropertyType',
        tn: 'ML_AffineCS_PropertyType',
        ps: [{
            n: 'mlAffineCS',
            rq: true,
            en: 'ML_AffineCS',
            ti: '.MLAffineCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLCartesianCSPropertyType',
        tn: 'ML_CartesianCS_PropertyType',
        ps: [{
            n: 'mlCartesianCS',
            rq: true,
            en: 'ML_CartesianCS',
            ti: '.MLCartesianCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTOperationParametersPropertyType',
        tn: 'CT_OperationParameters_PropertyType',
        ps: [{
            n: 'abstractGeneralOperationParameter',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractGeneralOperationParameter',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.AbstractGeneralOperationParameterType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLOperationParameterType',
        tn: 'ML_OperationParameter_Type',
        bti: 'GML_3_2_0.OperationParameterType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationParameterAltPropertyType'
          }]
      }, {
        ln: 'MLLinearCSPropertyType',
        tn: 'ML_LinearCS_PropertyType',
        ps: [{
            n: 'mlLinearCS',
            rq: true,
            en: 'ML_LinearCS',
            ti: '.MLLinearCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCodelistCatalogueType',
        tn: 'CT_CodelistCatalogue_Type',
        bti: '.AbstractCTCatalogueType',
        ps: [{
            n: 'codelistItem',
            rq: true,
            col: true,
            ti: '.CTCodelistPropertyType'
          }]
      }, {
        ln: 'MLVerticalCSPropertyType',
        tn: 'ML_VerticalCS_PropertyType',
        ps: [{
            n: 'mlVerticalCS',
            rq: true,
            en: 'ML_VerticalCS',
            ti: '.MLVerticalCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ConventionalUnitPropertyType',
        tn: 'ConventionalUnit_PropertyType',
        ps: [{
            n: 'conventionalUnit',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'ConventionalUnit',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.ConventionalUnitType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CoordinateSystemAxisAltPropertyType',
        tn: 'CoordinateSystemAxisAlt_PropertyType',
        ps: [{
            n: 'coordinateSystemAxisAlt',
            rq: true,
            en: 'CoordinateSystemAxisAlt',
            ti: '.CoordinateSystemAxisAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MXDataSetType',
        tn: 'MX_DataSet_Type',
        bti: 'ISO19139_GMD_20060504.DSDataSetType',
        ps: [{
            n: 'dataFile',
            rq: true,
            col: true,
            ti: '.MXDataFilePropertyType'
          }, {
            n: 'datasetCatalogue',
            mno: 0,
            col: true,
            ti: '.CTCataloguePropertyType'
          }, {
            n: 'supportFile',
            mno: 0,
            col: true,
            ti: '.MXSupportFilePropertyType'
          }]
      }, {
        ln: 'MLProjectedCRSType',
        tn: 'ML_ProjectedCRS_Type',
        bti: 'GML_3_2_0.ProjectedCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'CTCRSPropertyType',
        tn: 'CT_CRS_PropertyType',
        ps: [{
            n: 'abstractCRS',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractCRS',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.AbstractCRSType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MXAggregatePropertyType',
        tn: 'MX_Aggregate_PropertyType',
        ps: [{
            n: 'mxAggregate',
            rq: true,
            en: 'MX_Aggregate',
            ti: '.MXAggregateType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLConventionalUnitType',
        tn: 'ML_ConventionalUnit_Type',
        bti: 'GML_3_2_0.ConventionalUnitType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.UomAlternativeExpressionPropertyType'
          }]
      }, {
        ln: 'DerivedUnitPropertyType',
        tn: 'DerivedUnit_PropertyType',
        ps: [{
            n: 'derivedUnit',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'DerivedUnit',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.DerivedUnitType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'FileNameType',
        tn: 'FileName_Type',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'src',
            an: {
              lp: 'src'
            },
            t: 'a'
          }]
      }, {
        ln: 'MXSupportFilePropertyType',
        tn: 'MX_SupportFile_PropertyType',
        ps: [{
            n: 'mxSupportFile',
            rq: true,
            en: 'MX_SupportFile',
            ti: '.MXSupportFileType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLDerivedUnitPropertyType',
        tn: 'ML_DerivedUnit_PropertyType',
        ps: [{
            n: 'mlDerivedUnit',
            rq: true,
            en: 'ML_DerivedUnit',
            ti: '.MLDerivedUnitType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'UomAlternativeExpressionType',
        tn: 'UomAlternativeExpression_Type',
        bti: 'GML_3_2_0.UnitDefinitionType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLCompoundCRSPropertyType',
        tn: 'ML_CompoundCRS_PropertyType',
        ps: [{
            n: 'mlCompoundCRS',
            rq: true,
            en: 'ML_CompoundCRS',
            ti: '.MLCompoundCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLConcatenatedOperationType',
        tn: 'ML_ConcatenatedOperation_Type',
        bti: 'GML_3_2_0.ConcatenatedOperationType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationAltPropertyType'
          }]
      }, {
        ln: 'CrsAltType',
        tn: 'CrsAlt_Type',
        bti: 'GML_3_2_0.AbstractCRSType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLPassThroughOperationPropertyType',
        tn: 'ML_PassThroughOperation_PropertyType',
        ps: [{
            n: 'mlPassThroughOperation',
            rq: true,
            en: 'ML_PassThroughOperation',
            ti: '.MLPassThroughOperationType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLUserDefinedCSType',
        tn: 'ML_UserDefinedCS_Type',
        bti: 'GML_3_2_0.UserDefinedCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'PrimeMeridianAltType',
        tn: 'PrimeMeridianAlt_Type',
        bti: 'GML_3_2_0.IdentifiedObjectType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'ClAlternativeExpressionType',
        tn: 'ClAlternativeExpression_Type',
        bti: 'GML_3_2_0.DefinitionType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'MXSupportFileType',
        tn: 'MX_SupportFile_Type',
        bti: '.AbstractMXFileType'
      }, {
        ln: 'MLCylindricalCSType',
        tn: 'ML_CylindricalCS_Type',
        bti: 'GML_3_2_0.CylindricalCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'OperationAltPropertyType',
        tn: 'OperationAlt_PropertyType',
        ps: [{
            n: 'operationAlt',
            rq: true,
            en: 'OperationAlt',
            ti: '.OperationAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLUserDefinedCSPropertyType',
        tn: 'ML_UserDefinedCS_PropertyType',
        ps: [{
            n: 'mlUserDefinedCS',
            rq: true,
            en: 'ML_UserDefinedCS',
            ti: '.MLUserDefinedCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AnchorType',
        tn: 'Anchor_Type',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLCartesianCSType',
        tn: 'ML_CartesianCS_Type',
        bti: 'GML_3_2_0.CartesianCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLEngineeringCRSPropertyType',
        tn: 'ML_EngineeringCRS_PropertyType',
        ps: [{
            n: 'mlEngineeringCRS',
            rq: true,
            en: 'ML_EngineeringCRS',
            ti: '.MLEngineeringCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CodeAlternativeExpressionPropertyType',
        tn: 'CodeAlternativeExpression_PropertyType',
        ps: [{
            n: 'codeAlternativeExpression',
            rq: true,
            en: 'CodeAlternativeExpression',
            ti: '.CodeAlternativeExpressionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ClAlternativeExpressionPropertyType',
        tn: 'ClAlternativeExpression_PropertyType',
        ps: [{
            n: 'clAlternativeExpression',
            rq: true,
            en: 'ClAlternativeExpression',
            ti: '.ClAlternativeExpressionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLImageCRSPropertyType',
        tn: 'ML_ImageCRS_PropertyType',
        ps: [{
            n: 'mlImageCRS',
            rq: true,
            en: 'ML_ImageCRS',
            ti: '.MLImageCRSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCodelistCataloguePropertyType',
        tn: 'CT_CodelistCatalogue_PropertyType',
        ps: [{
            n: 'ctCodelistCatalogue',
            rq: true,
            en: 'CT_CodelistCatalogue',
            ti: '.CTCodelistCatalogueType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLLinearCSType',
        tn: 'ML_LinearCS_Type',
        bti: 'GML_3_2_0.LinearCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'CoordinateSystemAxisAltType',
        tn: 'CoordinateSystemAxisAlt_Type',
        bti: 'GML_3_2_0.CoordinateSystemAxisType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'CodeListDictionaryType',
        tn: 'CodeListDictionary_Type',
        bti: 'GML_3_2_0.DictionaryType',
        ps: [{
            n: 'codeEntry',
            rq: true,
            col: true,
            ti: '.CodeDefinitionPropertyType'
          }]
      }, {
        ln: 'CTUomCataloguePropertyType',
        tn: 'CT_UomCatalogue_PropertyType',
        ps: [{
            n: 'ctUomCatalogue',
            rq: true,
            en: 'CT_UomCatalogue',
            ti: '.CTUomCatalogueType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'UomAlternativeExpressionPropertyType',
        tn: 'UomAlternativeExpression_PropertyType',
        ps: [{
            n: 'uomAlternativeExpression',
            rq: true,
            en: 'UomAlternativeExpression',
            ti: '.UomAlternativeExpressionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTOperationMethodPropertyType',
        tn: 'CT_OperationMethod_PropertyType',
        ps: [{
            n: 'operationMethod',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'OperationMethod',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.OperationMethodType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLGeodeticDatumPropertyType',
        tn: 'ML_GeodeticDatum_PropertyType',
        ps: [{
            n: 'mlGeodeticDatum',
            rq: true,
            en: 'ML_GeodeticDatum',
            ti: '.MLGeodeticDatumType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLAffineCSType',
        tn: 'ML_AffineCS_Type',
        bti: 'GML_3_2_0.AffineCSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CoordinateSystemAltPropertyType'
          }]
      }, {
        ln: 'MLTemporalDatumType',
        tn: 'ML_TemporalDatum_Type',
        bti: 'GML_3_2_0.TemporalDatumType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.DatumAltPropertyType'
          }]
      }, {
        ln: 'MLOperationMethodType',
        tn: 'ML_OperationMethod_Type',
        bti: 'GML_3_2_0.OperationMethodType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationMethodAltPropertyType'
          }]
      }, {
        ln: 'MLSphericalCSPropertyType',
        tn: 'ML_SphericalCS_PropertyType',
        ps: [{
            n: 'mlSphericalCS',
            rq: true,
            en: 'ML_SphericalCS',
            ti: '.MLSphericalCSType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MXDataSetPropertyType',
        tn: 'MX_DataSet_PropertyType',
        ps: [{
            n: 'mxDataSet',
            rq: true,
            en: 'MX_DataSet',
            ti: '.MXDataSetType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLConversionPropertyType',
        tn: 'ML_Conversion_PropertyType',
        ps: [{
            n: 'mlConversion',
            rq: true,
            en: 'ML_Conversion',
            ti: '.MLConversionType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCrsCatalogueType',
        tn: 'CT_CrsCatalogue_Type',
        bti: '.AbstractCTCatalogueType',
        ps: [{
            n: 'crs',
            rq: true,
            col: true,
            ti: '.CTCRSPropertyType'
          }, {
            n: 'coordinateSystem',
            mno: 0,
            col: true,
            ti: '.CTCoordinateSystemPropertyType'
          }, {
            n: 'axis',
            mno: 0,
            col: true,
            ti: '.CTCoordinateSystemAxisPropertyType'
          }, {
            n: 'datum',
            mno: 0,
            col: true,
            ti: '.CTDatumPropertyType'
          }, {
            n: 'ellipsoid',
            mno: 0,
            col: true,
            ti: '.CTEllipsoidPropertyType'
          }, {
            n: 'primeMeridian',
            mno: 0,
            col: true,
            ti: '.CTPrimeMeridianPropertyType'
          }, {
            n: 'operation',
            mno: 0,
            col: true,
            ti: '.CTOperationPropertyType'
          }, {
            n: 'operationMethod',
            mno: 0,
            col: true,
            ti: '.CTOperationMethodPropertyType'
          }, {
            n: 'parameters',
            mno: 0,
            col: true,
            ti: '.CTOperationParametersPropertyType'
          }]
      }, {
        ln: 'OperationMethodAltPropertyType',
        tn: 'OperationMethodAlt_PropertyType',
        ps: [{
            n: 'operationMethodAlt',
            rq: true,
            en: 'OperationMethodAlt',
            ti: '.OperationMethodAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DatumAltPropertyType',
        tn: 'DatumAlt_PropertyType',
        ps: [{
            n: 'datumAlt',
            rq: true,
            en: 'DatumAlt',
            ti: '.DatumAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MimeFileTypeType',
        tn: 'MimeFileType_Type',
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }]
      }, {
        ln: 'CoordinateSystemAltType',
        tn: 'CoordinateSystemAlt_Type',
        bti: 'GML_3_2_0.IdentifiedObjectType',
        ps: [{
            n: 'locale',
            rq: true,
            ti: 'ISO19139_GMD_20060504.PTLocalePropertyType'
          }, {
            n: 'codeSpace',
            rq: true,
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }, {
            n: 'aggregationType',
            ti: 'GML_3_2_0.AggregationType',
            an: {
              lp: 'aggregationType'
            },
            t: 'a'
          }]
      }, {
        ln: 'MLCompoundCRSType',
        tn: 'ML_CompoundCRS_Type',
        bti: 'GML_3_2_0.CompoundCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'MXDataFileType',
        tn: 'MX_DataFile_Type',
        bti: '.AbstractMXFileType',
        ps: [{
            n: 'featureTypes',
            mno: 0,
            col: true,
            ti: 'ISO19139_GCO_20060504.GenericNamePropertyType'
          }, {
            n: 'fileFormat',
            rq: true,
            ti: 'ISO19139_GMD_20060504.MDFormatPropertyType'
          }]
      }, {
        ln: 'MLDerivedCRSType',
        tn: 'ML_DerivedCRS_Type',
        bti: 'GML_3_2_0.DerivedCRSType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.CrsAltPropertyType'
          }]
      }, {
        ln: 'MLEllipsoidType',
        tn: 'ML_Ellipsoid_Type',
        bti: 'GML_3_2_0.EllipsoidType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.EllipsoidAltPropertyType'
          }]
      }, {
        ln: 'MLTransformationType',
        tn: 'ML_Transformation_Type',
        bti: 'GML_3_2_0.TransformationType',
        ps: [{
            n: 'alternativeExpression',
            rq: true,
            col: true,
            ti: '.OperationAltPropertyType'
          }]
      }, {
        ln: 'CTOperationPropertyType',
        tn: 'CT_Operation_PropertyType',
        ps: [{
            n: 'abstractCoordinateOperation',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractCoordinateOperation',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.AbstractCoordinateOperationType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CTCoordinateSystemPropertyType',
        tn: 'CT_CoordinateSystem_PropertyType',
        ps: [{
            n: 'abstractCoordinateSystem',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractCoordinateSystem',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_2_0.AbstractCoordinateSystemType',
            t: 'er'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'CrsAltPropertyType',
        tn: 'CrsAlt_PropertyType',
        ps: [{
            n: 'crsAlt',
            rq: true,
            en: 'CrsAlt',
            ti: '.CrsAltType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MLCoordinateSystemAxisPropertyType',
        tn: 'ML_CoordinateSystemAxis_PropertyType',
        ps: [{
            n: 'mlCoordinateSystemAxis',
            rq: true,
            en: 'ML_CoordinateSystemAxis',
            ti: '.MLCoordinateSystemAxisType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }, {
            n: 'uuidref',
            an: {
              lp: 'uuidref'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AnchorPropertyType',
        tn: 'Anchor_PropertyType',
        ps: [{
            n: 'anchor',
            rq: true,
            en: 'Anchor',
            ti: '.AnchorType'
          }, {
            n: 'nilReason',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nilReason',
              ns: 'http:\/\/www.isotc211.org\/2005\/gco'
            },
            t: 'a'
          }]
      }],
    eis: [{
        en: 'ML_PolarCS',
        ti: '.MLPolarCSType',
        sh: {
          lp: 'PolarCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CoordinateSystemAxisAlt',
        ti: '.CoordinateSystemAxisAltType'
      }, {
        en: 'ML_ConcatenatedOperation',
        ti: '.MLConcatenatedOperationType',
        sh: {
          lp: 'ConcatenatedOperation',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CT_UomCatalogue',
        ti: '.CTUomCatalogueType',
        sh: 'AbstractCT_Catalogue'
      }, {
        en: 'CoordinateSystemAlt',
        ti: '.CoordinateSystemAltType'
      }, {
        en: 'OperationAlt',
        ti: '.OperationAltType'
      }, {
        en: 'MX_DataFile',
        ti: '.MXDataFileType',
        sh: 'AbstractMX_File'
      }, {
        en: 'ML_OperationMethod',
        ti: '.MLOperationMethodType',
        sh: {
          lp: 'OperationMethod',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_UnitDefinition',
        ti: '.MLUnitDefinitionType',
        sh: {
          lp: 'UnitDefinition',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'PrimeMeridianAlt',
        ti: '.PrimeMeridianAltType'
      }, {
        en: 'MimeFileType',
        ti: '.MimeFileTypeType',
        sh: {
          lp: 'CharacterString',
          ns: 'http:\/\/www.isotc211.org\/2005\/gco'
        }
      }, {
        en: 'ML_EngineeringCRS',
        ti: '.MLEngineeringCRSType',
        sh: {
          lp: 'EngineeringCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'MX_ScopeCode',
        ti: 'ISO19139_GCO_20060504.CodeListValueType',
        sh: {
          lp: 'MD_ScopeCode',
          ns: 'http:\/\/www.isotc211.org\/2005\/gmd'
        }
      }, {
        en: 'CT_CodelistCatalogue',
        ti: '.CTCodelistCatalogueType',
        sh: 'AbstractCT_Catalogue'
      }, {
        en: 'ML_PrimeMeridian',
        ti: '.MLPrimeMeridianType',
        sh: {
          lp: 'PrimeMeridian',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'EllipsoidAlt',
        ti: '.EllipsoidAltType'
      }, {
        en: 'FileName',
        ti: '.FileNameType',
        sh: {
          lp: 'CharacterString',
          ns: 'http:\/\/www.isotc211.org\/2005\/gco'
        }
      }, {
        en: 'ML_OperationParameter',
        ti: '.MLOperationParameterType',
        sh: {
          lp: 'OperationParameter',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'Anchor',
        ti: '.AnchorType',
        sh: {
          lp: 'CharacterString',
          ns: 'http:\/\/www.isotc211.org\/2005\/gco'
        }
      }, {
        en: 'ML_CoordinateSystemAxis',
        ti: '.MLCoordinateSystemAxisType',
        sh: {
          lp: 'CoordinateSystemAxis',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CodeAlternativeExpression',
        ti: '.CodeAlternativeExpressionType'
      }, {
        en: 'ML_ProjectedCRS',
        ti: '.MLProjectedCRSType',
        sh: {
          lp: 'ProjectedCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_DerivedCRS',
        ti: '.MLDerivedCRSType',
        sh: {
          lp: 'DerivedCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_CylindricalCS',
        ti: '.MLCylindricalCSType',
        sh: {
          lp: 'CylindricalCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'AbstractCT_Catalogue',
        ti: '.AbstractCTCatalogueType'
      }, {
        en: 'ML_CartesianCS',
        ti: '.MLCartesianCSType',
        sh: {
          lp: 'CartesianCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_TemporalDatum',
        ti: '.MLTemporalDatumType',
        sh: {
          lp: 'TemporalDatum',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_GeodeticCRS',
        ti: '.MLGeodeticCRSType',
        sh: {
          lp: 'GeodeticCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_EngineeringDatum',
        ti: '.MLEngineeringDatumType',
        sh: {
          lp: 'EngineeringDatum',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CodeListDictionary',
        ti: '.CodeListDictionaryType',
        sh: {
          lp: 'Dictionary',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ClAlternativeExpression',
        ti: '.ClAlternativeExpressionType'
      }, {
        en: 'ML_GeodeticDatum',
        ti: '.MLGeodeticDatumType',
        sh: {
          lp: 'GeodeticDatum',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_VerticalCRS',
        ti: '.MLVerticalCRSType',
        sh: {
          lp: 'VerticalCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'OperationParameterAlt',
        ti: '.OperationParameterAltType'
      }, {
        en: 'MX_SupportFile',
        ti: '.MXSupportFileType',
        sh: 'AbstractMX_File'
      }, {
        en: 'ML_SphericalCS',
        ti: '.MLSphericalCSType',
        sh: {
          lp: 'SphericalCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'AbstractMX_File',
        ti: '.AbstractMXFileType'
      }, {
        en: 'ML_VerticalCS',
        ti: '.MLVerticalCSType',
        sh: {
          lp: 'VerticalCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'DatumAlt',
        ti: '.DatumAltType'
      }, {
        en: 'ML_ImageDatum',
        ti: '.MLImageDatumType',
        sh: {
          lp: 'ImageDatum',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'OperationMethodAlt',
        ti: '.OperationMethodAltType'
      }, {
        en: 'ML_ImageCRS',
        ti: '.MLImageCRSType',
        sh: {
          lp: 'ImageCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_ConventionalUnit',
        ti: '.MLConventionalUnitType',
        sh: {
          lp: 'ConventionalUnit',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_Ellipsoid',
        ti: '.MLEllipsoidType',
        sh: {
          lp: 'Ellipsoid',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CT_CrsCatalogue',
        ti: '.CTCrsCatalogueType',
        sh: 'AbstractCT_Catalogue'
      }, {
        en: 'UomAlternativeExpression',
        ti: '.UomAlternativeExpressionType'
      }, {
        en: 'CodeDefinition',
        ti: '.CodeDefinitionType',
        sh: {
          lp: 'Definition',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_CompoundCRS',
        ti: '.MLCompoundCRSType',
        sh: {
          lp: 'CompoundCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_EllipsoidalCS',
        ti: '.MLEllipsoidalCSType',
        sh: {
          lp: 'EllipsoidalCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'CrsAlt',
        ti: '.CrsAltType'
      }, {
        en: 'ML_OperationParameterGroup',
        ti: '.MLOperationParameterGroupType',
        sh: {
          lp: 'OperationParameterGroup',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_Transformation',
        ti: '.MLTransformationType',
        sh: {
          lp: 'Transformation',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_DerivedUnit',
        ti: '.MLDerivedUnitType',
        sh: {
          lp: 'DerivedUnit',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_TimeCS',
        ti: '.MLTimeCSType',
        sh: {
          lp: 'TimeCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_VerticalDatum',
        ti: '.MLVerticalDatumType',
        sh: {
          lp: 'VerticalDatum',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_CodeListDictionary',
        ti: '.MLCodeListDictionaryType',
        sh: 'CodeListDictionary'
      }, {
        en: 'ML_LinearCS',
        ti: '.MLLinearCSType',
        sh: {
          lp: 'LinearCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_Conversion',
        ti: '.MLConversionType',
        sh: {
          lp: 'Conversion',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'MX_Aggregate',
        ti: '.MXAggregateType',
        sh: {
          lp: 'AbstractDS_Aggregate',
          ns: 'http:\/\/www.isotc211.org\/2005\/gmd'
        }
      }, {
        en: 'ML_CodeDefinition',
        ti: '.MLCodeDefinitionType',
        sh: 'CodeDefinition'
      }, {
        en: 'ML_UserDefinedCS',
        ti: '.MLUserDefinedCSType',
        sh: {
          lp: 'UserDefinedCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_AffineCS',
        ti: '.MLAffineCSType',
        sh: {
          lp: 'AffineCS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_PassThroughOperation',
        ti: '.MLPassThroughOperationType',
        sh: {
          lp: 'PassThroughOperation',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_TemporalCRS',
        ti: '.MLTemporalCRSType',
        sh: {
          lp: 'TemporalCRS',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'ML_BaseUnit',
        ti: '.MLBaseUnitType',
        sh: {
          lp: 'BaseUnit',
          ns: 'http:\/\/www.opengis.net\/gml'
        }
      }, {
        en: 'MX_DataSet',
        ti: '.MXDataSetType',
        sh: {
          lp: 'DS_DataSet',
          ns: 'http:\/\/www.isotc211.org\/2005\/gmd'
        }
      }]
  };
  return {
    ISO19139_GMX_20060504: ISO19139_GMX_20060504
  };
};
if (typeof define === 'function' && define.amd) {
  define([], ISO19139_GMX_20060504_Module_Factory);
}
else {
  var ISO19139_GMX_20060504_Module = ISO19139_GMX_20060504_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.ISO19139_GMX_20060504 = ISO19139_GMX_20060504_Module.ISO19139_GMX_20060504;
  }
  else {
    var ISO19139_GMX_20060504 = ISO19139_GMX_20060504_Module.ISO19139_GMX_20060504;
  }
}